import Tweet from "./Tweet";
import {useSearchParams} from "react-router-dom";
import useAxiosRequest from "../hooks/useAxiosRequest";
import config from "../config.json";

const TweetRenderer = () => {
    const [ searchParams ] = useSearchParams();

    const { data, isLoading } = useAxiosRequest({
        url: `${config.backendUrl}/tweet/data?id=${searchParams.get("data")}`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading) return;

    return <Tweet {...data}/>
}

export default TweetRenderer;
